import api from "./apiVotar";

// Controle de "já votou": vale a união do que está guardado neste navegador com o que a API tem registrado
// para a unidade. Assim limpar o navegador, sair/entrar de novo ou trocar de aparelho não reabre uma pauta votada.
const chave = (votacaoId, unidadeId) => `va-votar-respondidas@${votacaoId}@${unidadeId}`;

export const lerRespondidas = (votacaoId, unidadeId) => {
  try {
    const lista = JSON.parse(localStorage.getItem(chave(votacaoId, unidadeId)));
    return Array.isArray(lista) ? lista : [];
  } catch (e) {
    return [];
  }
};

export const salvarRespondida = (votacaoId, unidadeId, perguntaId) => {
  try {
    const atuais = lerRespondidas(votacaoId, unidadeId);
    if (atuais.includes(perguntaId)) return;
    localStorage.setItem(chave(votacaoId, unidadeId), JSON.stringify([...atuais, perguntaId]));
  } catch (e) {
    /* sem armazenamento: o voto já foi registrado na API */
  }
};

// Ids das perguntas em que a unidade aparece entre os votos (resposta de /resultadoPerguntasByVotacaoId).
export const votadasNoServidor = (resultado, unidadeId) => {
  const ids = [];
  ((resultado && resultado.perguntas) || []).forEach(pergunta => {
    const votou = (pergunta.respostas || []).some(r => (r.votos || []).some(v => String(v._id) === String(unidadeId)));
    if (votou) ids.push(String(pergunta._id));
  });
  return ids;
};

// União local + servidor; a consulta ao servidor é opcional (falha de rede não impede de votar).
export const obterRespondidas = async (sessao, votacaoId) => {
  const unidadeId = sessao.unidade._id;
  const locais = lerRespondidas(votacaoId, unidadeId);
  let servidor = [];
  try {
    const resultado = await api.resultado(sessao.token, sessao.unidade.condominio._id, votacaoId);
    servidor = votadasNoServidor(resultado, unidadeId);
  } catch (e) {
    /* sem confirmação do servidor: vale o que está no navegador */
  }
  servidor.forEach(id => salvarRespondida(votacaoId, unidadeId, id));
  return Array.from(new Set([...locais, ...servidor]));
};

export const pendentes = (perguntas, respondidas) => (perguntas || []).filter(p => !respondidas.includes(String(p._id)));
